import { render, staticRenderFns } from "./DelegationsOverview.vue?vue&type=template&id=1815113a&scoped=true&"
import script from "./DelegationsOverview.vue?vue&type=script&lang=js&"
export * from "./DelegationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./DelegationsOverview.vue?vue&type=style&index=0&id=1815113a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815113a",
  null
  
)

export default component.exports